import type { Session, SessionStore } from './http';

/**
 * Tokens in localStorage under `key`, so every tab of an app shares one sign-in. If storage is
 * blocked, the session lasts as long as the page.
 */
export function localSessionStore(key: string): SessionStore {
  let memory: Session | null = null;
  return {
    get() {
      try {
        const value = localStorage.getItem(key);
        if (value === null) return memory;
        const session = JSON.parse(value) as Partial<Session>;
        return session.accessToken && session.refreshToken ? (session as Session) : null;
      } catch {
        return memory;
      }
    },
    set(session) {
      memory = session;
      try {
        if (session) localStorage.setItem(key, JSON.stringify(session));
        else localStorage.removeItem(key);
      } catch {
        // storage blocked: `memory` carries it
      }
    },
  };
}
